import React from "react";
import BooleanToggle from "../../toggle/booleanToggle"
import Dropdown from "../../dropdown/dropdown";
import TextInput from "../../textinput/textInput";
import { extparDropdowns, ilookupOptions } from "../../dropdown/options";
import { floatNumber, positiveInt100 } from "../../../regex/REGEX";

function Extpar({ domains, domainIndex, setExtparField, advancedmode }) {

	const handleIluType = (field, newVal) => {
		setExtparField(domainIndex, field, newVal)
		setExtparField(domainIndex, "l_use_corine", false)
		setExtparField(domainIndex, "ilookup_table_lu", 1)
	}

	return (
		<div className="extpar-options">
			<h2 className={"content-title"} id="extpar-parameters">EXTPAR Parameters Domain {domainIndex + 1}</h2>
			<div className={"content-extpar"}>
				{extparDropdowns.map((entry, index) => {
					return (
						<Dropdown
							key={index}
							config={entry}
							setStateField={(field, newValue) => field === "ilu_type" ? handleIluType(field, newValue) : setExtparField(domainIndex, field, newValue)}
							activeOptionIndex={domains[domainIndex].extpar[entry.fieldName] - 1}
							hint={domains[domainIndex].extpar.itopo_type === 2 &&
								entry.fieldName === "itopo_type" ? "Domains using ASTER cannot exeed 60N or 60S" : null}
						/>
					);
				})}
				{advancedmode &&
					<React.Fragment>
						{(domains[domainIndex].extpar.ilu_type === 1 || domains[domainIndex].extpar.ilu_type === 2) &&
							<Dropdown
								config={{
									options: ilookupOptions[domains[domainIndex].extpar.ilu_type],
									fieldName: "ilookup_table_lu",
									tooltip: "Switch to choose a lookup table.",
									docsLink: "https://c2sm.github.io/extpar/user_manual/user_manual_06_namelist_input/#namelist-lu_raw_data-input_lu"
								}}
								setStateField={(field, newValue) => setExtparField(domainIndex, field, newValue)}
								activeOptionIndex={domains[domainIndex].extpar.ilookup_table_lu - 1}
							/>
						}
						<BooleanToggle
							index={domainIndex}
							config={{
								fieldName: "enable_cdnc",
								tooltip: "Enables the usage of CDNC data.",
								docsLink: "https://c2sm.github.io/extpar/user_manual/user_manual_06_namelist_input/#cdnc-data"
							}}
							label={"enable_cdnc"}
							left={"false"}
							right={"true"}
							setStateField={(field, value) => setExtparField(domainIndex, field, value)}
							state={domains[domainIndex].extpar.enable_cdnc}
						/>
						<BooleanToggle
							index={domainIndex}
							config={{
								fieldName: "enable_edgar",
								tooltip: "Enables the usage of EDGAR data.",
								docsLink: "https://c2sm.github.io/extpar/user_manual/user_manual_06_namelist_input/#edgar-data"
							}}
							label={"enable_edgar"}
							left={"false"}
							right={"true"}
							setStateField={(field, value) => setExtparField(domainIndex, field, value)}
							state={domains[domainIndex].extpar.enable_edgar}
						/>
						<BooleanToggle
							index={domainIndex}
							config={{
								fieldName: "enable_art",
								tooltip: "Enables the usage of ART data.",
								docsLink: "https://c2sm.github.io/extpar/user_manual/user_manual_06_namelist_input/#art-data"
							}}
							label={"enable_art"}
							left={"false"}
							right={"true"}
							setStateField={(field, value) => setExtparField(domainIndex, field, value)}
							state={domains[domainIndex].extpar.enable_art}
						/>
						{domains[domainIndex].extpar.ilu_type === 1 &&
							<BooleanToggle
								index={domainIndex}
								config={{
									fieldName: "l_use_corine",
									tooltip: "Switch to use Corine land use dataset.",
									docsLink: "https://c2sm.github.io/extpar/user_manual/user_manual_06_namelist_input/#namelist-lu_raw_data-input_lu"
								}}
								label={"l_use_corine"}
								left={"false"}
								right={"true"}
								setStateField={(field, value) => setExtparField(domainIndex, field, value)}
								state={domains[domainIndex].extpar.l_use_corine}
							/>

						}
						<BooleanToggle
							index={domainIndex}
							config={{
								fieldName: "lradtopo",
								tooltip: "Switch for radiation corrected topography parameters.",
								docsLink: "https://c2sm.github.io/extpar/user_manual/user_manual_06_namelist_input/#namelist-radtopo-input_radtopo"
							}}
							label={"lradtopo"}
							left={"false"}
							right={"true"}
							setStateField={(field, value) => setExtparField(domainIndex, field, value)}
							state={domains[domainIndex].extpar.lradtopo}
						/>
						{domains[domainIndex].extpar.lradtopo &&
							<React.Fragment>
								<TextInput
									field={"radtopo_radius"}
									value={domains[domainIndex].extpar.radtopo_radius}
									tooltipMessage={"Radial distance considered for computation of horizon"}
									docsLink={"https://c2sm.github.io/extpar/user_manual/user_manual_06_namelist_input/#namelist-radtopo-input_radtopo"}
									validRegex={floatNumber}
									allowRegex={/^[0-9.-]*$/}
									updateStateField={(field, value) => setExtparField(domainIndex, field, value)}
								/>
								<TextInput
									field={"nhori"}
									value={domains[domainIndex].extpar.nhori}
									tooltipMessage={"Number of horizon angles"}
									docsLink={"https://c2sm.github.io/extpar/user_manual/user_manual_06_namelist_input/#namelist-radtopo-input_radtopo"}
									validRegex={positiveInt100}
									allowRegex={/^[0-9]*$/}
									updateStateField={(field, value) => setExtparField(domainIndex, field, value)}
								/>
							</React.Fragment>
						}

					</React.Fragment>
				}
			</div>
		</div>
	)
}

export default Extpar;
